import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetSarpSitesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSarpSites`,
	params: {}
});

export const GetSarpReportRequest = (sarpSiteList, username, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/GetSarpReport`,
	data: { sarpSiteList, username, userId }
});

export const GetSarpSiteTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSarpSiteTable`
});

export const GetNopTrackerLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetNopTrackerLastUpdate`
});